import type {
	BenefitType,
	CalculationMethodType,
	SalaryPeriodType,
	VehicleSchemeType,
} from "@loanlink-nl/model-app";
import { BeroepType } from "@loanlink-nl/model-hdn/OfferteAanvraag";
import { addEmptyOption } from "@/composables/useXsdToFormKit";
import { hdnListToOptions } from "@/helpers/hdnHelpers";

export const professionTypeOptions = addEmptyOption(
	hdnListToOptions(BeroepType, {
		shouldSort: true,
	}),
);

type SelectOptionsMap<T extends string> = Record<T, string>;

type BenefitOptions = SelectOptionsMap<BenefitType>;

export const benefitOptions: BenefitOptions = {
	vakantietoeslag: "Vakantietoeslag",
	individueel_keuzebudget: "Structureel individueel keuzebudget",
	dertiende_maand: "13e maand",
	eindejaarsuitkering: "Eindejaarsuitkering",
	winstdeling: "Winstdeling",
};

type VehicleSchemeOptions = SelectOptionsMap<VehicleSchemeType>;

export const vehicleSchemeOptions: VehicleSchemeOptions = {
	fixed: "Vast percentage fiscale bijtelling",
	variable: "Variabel percentage fiscale bijtelling",
	none: "Geen bijtelling",
};

type CalculationMethodOptions = SelectOptionsMap<CalculationMethodType>;

export const calculationMethodOptions: CalculationMethodOptions = {
	brutoJaarsalaris: "Bruto jaarsalaris",
	uwvVerzekeringsbericht: "UWV-verzekeringsbericht",
	arbeidsmarktscan: "Arbeidsmarktscan",
};

export const yesNoOptions = [
	{ label: "Ja", value: true },
	{ label: "Nee", value: false },
];

export const permanentPositionOptions = yesNoOptions;
export const hasCompanyVehicleOptions = yesNoOptions;

type SalaryPeriodOptions = SelectOptionsMap<SalaryPeriodType>;

export const salaryPeriodOptions: SalaryPeriodOptions = {
	jaar: "Jaar",
	maand: "Maand",
	"4weken": "4 weken",
};
